<template>
  <div class="app-container">
    <PageRoute />
    <div class="img-content" @click="showTree = false">
      <!-- 背景图 -->
      <img class="bg" src="@/assets/img/meterSelection/bg2x.jpg" />
      <!-- 顶部区域文案 -->
      <div class="text-content">
        说出你的需求 → 我们注入行业智慧 →
        <span style="color: #fff">获得精准方案</span>
      </div>
      <!-- 分类筛选区域 -->
      <div class="tree-content" @click.stop @mouseenter="showTree = true">
        <div class="tree-content-label">
          需求配置<i class="el-icon-arrow-down"></i>
        </div>
        <div class="meter-cascader" v-show="showTree">
          <!-- 分类组件 -->
          <div class="cascader-menu-wrap">
            <!-- 一级 -->
            <div class="cascader-menu">
              <div class="cascader-title">
                {{ categoryTitles[0] }} <i class="el-icon-arrow-right"></i>
              </div>
              <div class="cascader-menu__list">
                <div
                  class="cascader-node"
                  v-for="(item, index) in categoryTree"
                  :key="index"
                  :class="{
                    'in-active-path': choosedCategoryIds.includes(
                      item.categoryId
                    ),
                  }"
                  @mouseenter="firstHover(item)"
                >
                  <Tooltips :innerContent="item.categoryName" />
                </div>
                <div class="cascader-node" v-if="categoryTree.length === 0">
                  暂无分类
                </div>
              </div>
              <div class="cascader-menu-more">
                <i class="el-icon-arrow-down"></i>下滑更多
              </div>
            </div>
            <!-- 二级 -->
            <div class="cascader-menu" v-show="categorySecondTree.length > 0">
              <div class="cascader-title">
                {{ categoryTitles[1] }} <i class="el-icon-arrow-right"></i>
              </div>
              <div class="cascader-menu__list">
                <div
                  class="cascader-node"
                  v-for="(item, index) in categorySecondTree"
                  :key="index"
                  :class="{
                    'in-active-path': choosedCategoryIds.includes(
                      item.categoryId
                    ),
                  }"
                  @mouseenter="secondHover(item)"
                >
                  <Tooltips :innerContent="item.categoryName" />
                </div>
              </div>
              <div class="cascader-menu-more">
                <i class="el-icon-arrow-down"></i>下滑更多
              </div>
            </div>
            <!-- 三级 -->
            <div class="cascader-menu" v-show="categoryThirdTree.length > 0">
              <div class="cascader-title">
                {{ categoryTitles[2] }}
              </div>
              <div class="cascader-menu__list">
                <div
                  class="cascader-node"
                  v-for="(item, index) in categoryThirdTree"
                  :key="index"
                  :class="{
                    'in-active-path': choosedCategoryIds.includes(
                      item.categoryId
                    ),
                  }"
                  @mouseenter="thirdHover(item)"
                  @click="goConfig(item)"
                >
                  <Tooltips :innerContent="item.categoryName" />
                </div>
              </div>
              <div class="cascader-menu-more">
                <i class="el-icon-arrow-down"></i>下滑更多
              </div>
            </div>
          </div>
          <!-- 三级类目关联示意图 -->
          <div class="categoryThirdImg" v-show="categoryThirdImg">
            <!-- 显示图片 -->
            <ImageCom
              style="width: 140px; height: 140px"
              :src="categoryThirdImg"
            />
            <div class="tip">安装方式示意图</div>
          </div>
        </div>
      </div>
      <!-- 展示区域图片文案 -->
      <div class="text-area">
        <img class="text-01" src="@/assets/img/meterSelection/text1.png" />
        <br />
        <img class="text-02" src="@/assets/img/meterSelection/text2.png" />
        <br />
        <div class="text3-wrap">
          <img class="text-03" src="@/assets/img/meterSelection/text3.png" />
          <img
            class="text-03bg"
            src="@/assets/img/meterSelection/text3bg.png"
          />
          <img
            class="text-03bg-blur"
            src="@/assets/img/meterSelection/text3bg.png"
          />
        </div>
      </div>
    </div>

    <!-- 我们的优势 -->
    <div class="good-wrap">
      <div class="default-title">我们的优势</div>
      <div class="card-wrap">
        <div
          class="card-item box-shadow-animate"
          v-for="(item, index) in advantageList"
          :key="index"
        >
          <div class="card-title">{{ item.title }}</div>
          <div class="card-subTitle">{{ item.subTitle }}</div>
          <img :src="item.img" />
        </div>
      </div>
    </div>

    <!-- 我们的产品 -->
    <div class="product-wrap" v-if="productWall.length">
      <div class="default-title">我们的产品</div>
      <div class="card-wrap">
        <swiper ref="solutionRef" :options="swiperOption">
          <swiper-slide
            style="height: 470px"
            v-for="(item, index) in productWall"
            :key="index"
          >
            <div class="card-item-wrap">
              <div class="card-item box-shadow-animate noTranslate">
                <div class="card-item-container">
                  <div class="card-title" :title="item.productName">
                    <!-- <Tooltips :innerContent="item.productName" /> -->
                    {{ item.productName }}
                  </div>
                  <div class="card-subTitle">{{ item.introduction }}</div>
                </div>
                <img :src="item.productImg" />
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <SupportIcon />
  </div>
</template>

<script>
import PageRoute from './components/pageRoute.vue'
import Tooltips from '@/components/tooltipShow'
import ImageCom from '@/components/image/index.vue'
import '@/assets/scss/swiper/swiper.css' // 这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import SupportIcon from './components/supportIcon.vue'
import debounce from 'lodash/debounce'

export default {
  components: {
    PageRoute,
    Tooltips,
    ImageCom,
    swiper,
    swiperSlide,
    SupportIcon
  },
  data () {
    return {
      showTree: false,
      categoryTree: [], // 类目树
      categorySecondTree: [], // 二级类目
      categoryThirdTree: [], // 三级类目
      choosedCategoryIds: [], // 已选中类目id
      /* 我们的优势 */
      advantageList: [
        {
          title: '全球合作精准配置',
          subTitle:
            '与国内外知名厂商建立的长期战略合作关系，为客户提供高适配的专业产品配置方案',
          img: require('@/assets/img/meterSelection/good-01.png')
        },
        {
          title: '30 余年行业深耕经验',
          subTitle:
            '逾三十载深耕流程工业自动化领域积累的仪器仪表选型设计与工程应用经验',
          img: require('@/assets/img/meterSelection/good-02.png')
        },
        {
          title: '极速支持快速赋能',
          subTitle: '高效专业的技术支持服务，助力客户工程师快速提升更专业技能',
          img: require('@/assets/img/meterSelection/good-03.png')
        }
      ],
      // 产品墙
      productWall: [],
      // 轮播配置
      swiperOption: {
        // 自动轮播
        autoplay: {
          // 用户交互后自动播放短暂暂停后恢复
          disableOnInteraction: false,
          delay: 3000
        },
        // 轮播视图为5个
        slidesPerView: 5,
        loopAdditionalSlides: 10,
        // 不足5个居中
        centerInsufficientSlides: true,
        // 允许触摸滑动
        allowTouchMove: true,
        // 开启循环模式
        loop: true,
        // 开启鼠标滚轮控制Swiper切换
        mousewheel: false,
        // 绑定事件
        on: {
          // swiper初始化
          init: this.swiperInit
        }
      }
    }
  },
  mounted () {
    this.getTree()
    this.getWall()

    // 类目绑定滚动事件
    Array.from(
      document.querySelectorAll('.meter-cascader .cascader-menu__list')
    ).forEach((item, index) => {
      item.addEventListener('scroll', this.scrollIsBottom())
    })
  },
  beforeDestroy () {
    // 类目解绑滚动事件
    Array.from(
      document.querySelectorAll('.meter-cascader .cascader-menu__list')
    ).forEach((item, index) => {
      item.removeEventListener('scroll', this.scrollIsBottom())
    })
  },
  computed: {
    // 获取产品示意图
    categoryThirdImg () {
      if (this.choosedCategoryIds.length === 3) {
        const imgObj = this.categoryThirdTree.find(
          (item) => item.categoryId === this.choosedCategoryIds[2]
        )
        return (imgObj.diagramImgs || []).join(',')
      }
      return ''
    },
    // 获取类目标题
    categoryTitles () {
      const firstCategory = this.categoryTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[0]
      )
      const secondCategory = this.categorySecondTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[1]
      )
      const thirdCategory = this.categoryThirdTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[2]
      )
      return [
        (firstCategory && firstCategory.levelTitle) || '',
        (secondCategory && secondCategory.levelTitle) || '',
        (thirdCategory && thirdCategory.levelTitle) || '-'
      ]
    }
  },
  methods: {
    // 滚动底部下滑更多消失
    scrollIsBottom () {
      const menuList = Array.from(
        document.querySelectorAll('.meter-cascader .cascader-menu__list')
      )

      const menuMore = Array.from(
        document.querySelectorAll('.meter-cascader .cascader-menu-more')
      )

      return debounce(() => {
        menuMore.forEach((item, index) => {
          if (
            menuList[index].scrollTop + menuList[index].clientHeight ===
            menuList[index].scrollHeight
          ) {
            item.style.opacity = 0
          } else {
            item.style.opacity = 1
          }
        })
      }, 150)
    },
    handleMouseenter () {
      this.$refs.solutionRef.swiper.autoplay.stop()
    },
    handleMouseleave () {
      this.$refs.solutionRef.swiper.autoplay.start()
    },
    // 悬浮暂停，移出继续轮播
    swiperInit () {
      const swiperItems = Array.from(
        this.$refs.solutionRef.$el.querySelectorAll('.card-item')
      )
      swiperItems.forEach((item) => {
        item.addEventListener('mouseenter', this.handleMouseenter)
        item.addEventListener('mouseleave', this.handleMouseleave)
      })
    },
    // 获取产品墙
    getWall () {
      this.$http
        .post('/front/cross/commodity-user/design/productWall/list', {
          page: 1,
          limit: 200,
          shelf: true
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.productWall = (res.data && res.data.dataList) || []
            // 小于5个不开启自动轮播
            if (this.productWall.length <= 5) {
              this.swiperOption.loop = false
              this.swiperOption.allowTouchMove = false
            }
          }
        })
    },
    getTree () {
      this.$http
        .get('/front/cross/commodity-user/design/category/tree')
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.categoryTree = res.data || []
            // 默认值
            this.choosedCategoryIds = [this.categoryTree[0].categoryId]

            this.$nextTick(() => {
              this.scrollIsBottom()()
            })
          }
        })
    },
    // 一级类目hover事件
    firstHover (item) {
      if (
        this.choosedCategoryIds[0] === item.categoryId &&
        this.categorySecondTree.length
      ) {
        return
      }
      this.categorySecondTree = item.children || []
      this.categoryThirdTree = []
      // 默认选中二级类目第一条
      if (this.categorySecondTree.length) {
        this.choosedCategoryIds = [
          item.categoryId,
          this.categorySecondTree[0].categoryId
        ]
      } else {
        this.choosedCategoryIds = [item.categoryId]
      }

      this.$nextTick(() => {
        this.scrollIsBottom()()
      })
    },
    // 二级类目hover事件
    secondHover (item) {
      if (
        this.choosedCategoryIds[1] === item.categoryId &&
        this.categoryThirdTree.length
      ) {
        return
      }
      this.categoryThirdTree = item.children || []
      // 默认选中三级类目第一条
      if (this.categoryThirdTree.length) {
        this.choosedCategoryIds = [
          this.choosedCategoryIds[0],
          item.categoryId,
          this.categoryThirdTree[0].categoryId
        ]
      } else {
        this.choosedCategoryIds = [this.choosedCategoryIds[0], item.categoryId]
      }

      this.$nextTick(() => {
        this.scrollIsBottom()()
      })
    },
    // 三级类目hover事件
    thirdHover (item) {
      this.choosedCategoryIds = [
        this.choosedCategoryIds[0],
        this.choosedCategoryIds[1],
        item.categoryId
      ]

      this.$nextTick(() => {
        this.scrollIsBottom()()
      })
    },
    // 跳往配置页面
    goConfig () {
      this.$router.push({
        path: '/meterSelectionConfig',
        query: {
          thirdCategoryId: this.choosedCategoryIds[2]
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  max-width: 1200px;
  width: 1200px;
  margin: 0 auto;
  font-family: Alibaba PuHuiTi;
}

.img-content {
  position: relative;
  user-select: none;
  border-radius: 16px;
  overflow: hidden;

  .bg {
    width: 100%;
  }

  .text-content {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    background: rgba(42, 84, 209, 0.8);
    padding: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-bottom-right-radius: 16px;
  }

  .tree-content {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 55px;

    .tree-content-label {
      color: #2a54d1;
      font-size: 14px;
      padding: 6px 12px;
      background: rgba(255, 255, 255, 0.99);
      border: 1px solid rgba(42, 84, 209, 0.2);
      border-radius: 0px 14px 14px 0px;
      cursor: pointer;
      display: inline-block;

      i {
        margin-left: 6px;
      }
    }

    .meter-cascader {
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(255, 255, 255, 0.9);
      max-width: 980px;
      border: none;
      display: flex;
      border-radius: 0 4px 4px 0;

      .cascader-menu-wrap {
        display: flex;
      }

      .cascader-menu {
        border-radius: 0 4px 4px 0;
        width: 180px;
        padding-top: 10px;
        color: #666666;

        .cascader-title {
          padding: 0 25px;
          height: 34px;
          line-height: 34px;
          font-weight: bold;
          color: #1a1a1a;
        }

        .cascader-menu__list {
          height: 247px;
          overflow-x: hidden;
          overflow-y: auto;
          margin-right: 10px;

          .cascader-node {
            padding: 0 25px;
            height: 34px;
            line-height: 34px;

            &.in-active-path {
              color: #2a54d1;
            }

            &:not(.is-disabled):hover,
            &:not(.is-disabled):focus {
              color: #2a54d1;
            }
          }

          &::-webkit-scrollbar {
            width: 4px; /* 宽度 */
            height: 4px;
          }

          &::-webkit-scrollbar-track {
            background: rgba(0, 0, 0, 0.1);
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.3);
          }
        }

        .cascader-menu-more {
          text-align: center;
          font-size: 14px;
          line-height: 24px;
          color: #ffffff;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
          margin-top: 4px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          i {
            margin-right: 4px;
          }
        }

        &:first-child {
          background: rgba(40, 75, 181, 0.9);
          color: rgba(255, 255, 255, 0.5);

          .cascader-title {
            color: #fff;
          }

          .cascader-menu__list {
            .cascader-node {
              &.in-active-path {
                color: #fff;
              }

              &:not(.is-disabled):hover,
              &:not(.is-disabled):focus {
                color: #fff;
              }
            }
          }

          .cascader-menu__list {
            &::-webkit-scrollbar-track {
              background: rgba(255, 255, 255, 0.2);
            }

            &::-webkit-scrollbar-thumb {
              background: #fff;
            }
          }
        }

        &:nth-child(2) {
          background: #fff;

          .cascader-menu-more {
            color: #666666;
            border-color: rgba(102, 102, 102, 0.2);
          }
        }

        &:nth-child(3) {
          color: #2e3234;

          .cascader-menu__list {
            .cascader-node {
              cursor: pointer;
            }
          }

          .cascader-menu-more {
            color: #666666;
            border-color: rgba(102, 102, 102, 0.2);
          }
        }
      }

      .categoryThirdImg {
        position: absolute;
        left: calc(100% + 12px);
        padding: 8px 8px 4px 8px;
        border-radius: 6px;
        background: rgba(255, 255, 255, 0.98);

        .tip {
          font-size: 12px;
          transform: scale(0.75);
          text-align: center;
          color: #999999;
        }
      }
    }
  }

  .text-area {
    position: absolute;
    z-index: 1;
    left: 8%;
    top: 36%;
    transform: scale(0.8);
    transform-origin: left top;
    pointer-events: none;

    .text-01 {
      margin-bottom: 20px;
      width: 471px;
    }

    .text-02 {
      margin-bottom: 20px;
      width: 310px;
    }

    .text3-wrap {
      position: relative;
      display: inline-block;

      .text-03 {
        position: absolute;
        transform: translate(-50%, -50%);
        z-index: 3;
        left: 50%;
        top: 50%;
        width: 246px;
      }

      .text-03bg {
        position: relative;
        z-index: 2;
      }

      .text-03bg-blur {
        filter: blur(20px);
        position: absolute;
        left: 0;
        top: 10px;
        z-index: 1;
        opacity: 0.3;
      }
    }
  }
}

.default-title {
  font-size: 32px;
  font-weight: bold;
  line-height: 44px;
  color: #3d3d3d;
  position: relative;
  text-align: center;

  &::after {
    content: "";
    height: 3px;
    width: 100px;
    background: #2a54d1;
    position: absolute;
    bottom: -3px;
    left: 50%;
    margin-left: -50px;
  }
}

.box-shadow-animate {
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);

  &:not(&.noTranslate) {
    &:hover {
      box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.3);
      transform: translate(-3px, -3px);
    }
  }

  &:hover {
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.3);
  }
}

.good-wrap {
  width: 1072px;
  margin: 40px auto 0;

  .card-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 60px;

    .card-item {
      text-align: center;
      width: 280px;
      height: 405px;
      border-radius: 2px;
      padding: 51px 0 18px;
      background: linear-gradient(180deg, #f2f6fc 0%, #ffffff 100%);
      position: relative;
      cursor: default;
      user-select: none;

      .card-title {
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: #3d3d3d;
      }

      .card-subTitle {
        font-size: 14px;
        font-weight: normal;
        line-height: 19px;
        color: #3d3d3d;
        width: 189px;
        margin: 23px auto;
        text-align: left;
      }

      &:nth-child(2) {
        .card-subTitle {
          width: 228px;
        }
      }

      img {
        width: 200px;
        position: absolute;
        bottom: 18px;
        left: 50%;
        margin-left: -100px;
      }
    }
  }
}

.product-wrap {
  width: 1200px;
  margin: 40px auto 0;

  .card-wrap {
    margin-top: 40px;

    .card-item-wrap {
      width: 240px;
      height: 470px;
      padding: 20px 20px 24px;

      .card-item {
        height: 100%;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        background: linear-gradient(180deg, #f2f6fc 0%, #ffffff 100%);

        &:hover {
          .card-item-container {
            height: 245px;

            .card-title {
              margin-bottom: 0;
            }
          }
        }
        .card-item-container {
          background: rgba(42, 84, 209, 0.8);
          padding: 12px 20px 0;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 53px;
          transition: all 0.3s ease-in-out;

          .card-title {
            font-size: 19px;
            line-height: 26px;
            color: #ffffff;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 14px;
            transition: all 0.3s linear;
          }

          .card-subTitle {
            font-size: 12px;
            margin-top: 8px;
            line-height: 16px;
            color: #ffffff;
            text-align: left;
          }
        }

        img {
          padding: 80px 30px 0;
          width: 100%;
          height: 298px;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
